export default "__VITE_ASSET__BoOfhC8O__"